import React, { Component } from "react";
import { Link } from "react-router-dom";
import "./index.css";

export default class RightMenu extends Component {
	constructor(props) {
		super(props);

		this.state = {
			rightMenu: props.data,
			prevDropdown: props.prev_dropdown ? props.prev_dropdown : []
		};
	}

	render() {
		//console.log("RightMenu", this.state);
		//console.log("RightMenu", this.props);
		return (
			<div className="RightMenu disctopMenuright">
				{this.state.prevDropdown === 2018 ? (
					<ul className="RightMenu list">
						{this.state.rightMenu.map(function (object, i) {
							return (
								<li className="RightMenu item" key={i}>
									<Link to={"/" + object.url}>{object.name}</Link>
								</li>
							);
						})}
					</ul>
				) : (
						<ul className="RightMenu list RightMenu__list--prevMenu">
							{this.state.rightMenu.map(function (object, i) {
								return (
									<li className="RightMenu item" key={i}>
										<Link to={"/" + object.url}>{object.name}</Link>
									</li>
								);
							})}
						</ul>
					)}
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/Components/Elements/RightMenu/index.js